import React from "react";

const RangeSlider = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  unit = "",
}) => {
  // Value'dan sayıyı çıkar (eğer unit ile geliyorsa)
  const numericValue = typeof value === "string" && unit 
    ? parseFloat(value.replace(unit, "")) || 0
    : (typeof value === "number" ? value : parseFloat(value) || 0);

  const handleValueChange = (newNumericValue) => {
    // Unit varsa ekle, yoksa sadece sayı gönder
    const finalValue = unit ? `${newNumericValue}${unit}` : newNumericValue;
    onChange(finalValue);
  };

  return (
    <div className="range-setting">
      <div className="range-label">
        <span>{label}:</span>
        <div className="range-actions">
          <input
            type="number"
            value={numericValue || ""}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (inputValue === "" || inputValue === null) {
                handleValueChange(0);
              } else {
                const numValue = Math.min(Math.max(Number(inputValue), min), max);
                handleValueChange(numValue);
              }
            }}
            min={min}
            max={max}
            step={step}
            className="range-number-input"
            placeholder={min === 0 ? "0 = Otomatik" : ""}
          />
          <span className="range-unit">{unit}</span>
        </div>
      </div>

      <div className="range-slider-container">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={numericValue || 0}
          onChange={(e) => {
            const numValue = Number(e.target.value);
            handleValueChange(numValue);
          }}
          className="range-slider"
          style={{
            background: `linear-gradient(to right, 
              var(--range-filled-color) 0%, 
              var(--range-filled-color) ${((numericValue - min) / (max - min)) * 100}%, 
              var(--range-empty-color) ${((numericValue - min) / (max - min)) * 100}%, 
              var(--range-empty-color) 100%)`,
          }}
        />
        <div className="range-ticks">
          <span>
            {min}
            {unit}
          </span>
          <span>
            {max}
            {unit}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
